import React, {useEffect, useState} from "react";
import "./CustomARB.css";
import parse from 'html-react-parser';
import CustomIndividualARB from "./CustomIndividualARB";
import { useAppContext } from "../../libs/contextLib";
import web3 from '../../web3';
import metakays from '../../metakays';
import { Link } from 'react-router-dom'




export default function CustomARB() {

  const {bgColor, four_colors, color1, color2, peices, showKustomModal, setKustomModal, setCustomChooser,  setMyMETAKAYS, setUserAccount} = useAppContext();

  const [msg1, setMsg1] = useState("");
  const [msg2, setMsg2] = useState("");
  const [msg3, setMsg3] = useState("");
  const [msg4, setMsg4] = useState("");
  const [msg5, setMsg5] = useState("");
  const [msg6, setMsg6] = useState("");



  useEffect(() => {
    const getMETAKAYS = async () => {

      try {

      const accounts = await web3.eth.getAccounts();
      setUserAccount(accounts[0])
      let supplyOfOwner = await metakays.methods.balanceOf(accounts[0]).call()
      for (let i = 0; i<supplyOfOwner; i++) {
        let tempID = await metakays.methods.tokenOfOwnerByIndex(accounts[0], i).call()
        let tempStruct = await metakays.methods.features(tempID).call()
        // let tokenURItest = await metakays.methods.tokenURI(2).call()


        setMyMETAKAYS(myMETAKAYS => ({...myMETAKAYS,
      [tempID]: Object.values(tempStruct).slice(0,13)}))

        }

      } catch (error) {
        console.log(error)

      }
      }

    getMETAKAYS();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var svgData = {}
  svgData[0] = '<use xlink:href="#hex" width="50" height="50" x="54" y="34';
  svgData[1] = '<use xlink:href="#hex" width="50" height="50" x="100" y="34';
  svgData[2] = '<use xlink:href="#hex" width="50" height="50" x="146" y="34';
  svgData[3] = '<use xlink:href="#hex" width="50" height="50" x="192" y="34';
  svgData[4] = '<use xlink:href="#hex" width="50" height="50" x="238" y="34';
  svgData[5] = '<use xlink:href="#hex" width="50" height="50" x="284" y="34';
  svgData[6] = '<use xlink:href="#hex" width="50" height="50" x="330" y="34';
  svgData[7] = '<use xlink:href="#hex" width="50" height="50" x="376" y="34';
  svgData[8] = '<use xlink:href="#hex" width="50" height="50" x="422" y="34';
  svgData[9] = '<use xlink:href="#hex" width="50" height="50" x="468" y="34';
  svgData[10] = '<use xlink:href="#hex" width="50" height="50" x="514" y="34';
  svgData[11] = '<use xlink:href="#hex" width="50" height="50" x="560" y="34';
  svgData[12] = '<use xlink:href="#hex" width="50" height="50" x="606" y="34';
  svgData[13] = '<use xlink:href="#hex" width="50" height="50" x="652" y="34';
  svgData[14] = '<use xlink:href="#hex" width="50" height="50" x="698" y="34';
  svgData[15] = '<use xlink:href="#hex" width="50" height="50" x="744" y="34';
  svgData[16] = '<use xlink:href="#hex" width="50" height="50" x="790" y="34';
  svgData[17] = '<use xlink:href="#hex" width="50" height="50" x="836" y="34';
  svgData[18] = '<use xlink:href="#hex" width="50" height="50" x="882" y="34';
  svgData[19] = '<use xlink:href="#hex" width="50" height="50" x="928" y="34';
  svgData[20] = '<use xlink:href="#hex" width="50" height="50" x="974" y="34';
  svgData[21] = '<use xlink:href="#hex" width="50" height="50" x="1020" y="34';
  svgData[22] = '<use xlink:href="#hex" width="50" height="50" x="1066" y="34';
  svgData[23] = '<use xlink:href="#hex" width="50" height="50" x="1112" y="34';
  svgData[24] = '<use xlink:href="#hex" width="50" height="50" x="1158" y="34';
  svgData[25] = '<use xlink:href="#hex" width="50" height="50" x="1204" y="34';
  svgData[26] = '<use xlink:href="#hex" width="50" height="50" x="1250" y="34';
  svgData[27] = '<use xlink:href="#hex" width="50" height="50" x="1296" y="34';
  svgData[28] = '<use xlink:href="#hex" width="50" height="50" x="1342" y="34';
  svgData[29] = '<use xlink:href="#hex" width="50" height="50" x="1388" y="34';
  svgData[30] = '<use xlink:href="#hex" width="50" height="50" x="1434" y="34';
  svgData[31] = '<use xlink:href="#hex" width="50" height="50" x="1480" y="34';
  svgData[32] = '<use xlink:href="#hex" width="50" height="50" x="31" y="74';
  svgData[33] = '<use xlink:href="#hex" width="50" height="50" x="77" y="74';
  svgData[34] = '<use xlink:href="#hex" width="50" height="50" x="123" y="74';
  svgData[35] = '<use xlink:href="#hex" width="50" height="50" x="169" y="74';
  svgData[36] = '<use xlink:href="#hex" width="50" height="50" x="215" y="74';
  svgData[37] = '<use xlink:href="#hex" width="50" height="50" x="261" y="74';
  svgData[38] = '<use xlink:href="#hex" width="50" height="50" x="307" y="74';
  svgData[39] = '<use xlink:href="#hex" width="50" height="50" x="353" y="74';
  svgData[40] = '<use xlink:href="#hex" width="50" height="50" x="399" y="74';
  svgData[41] = '<use xlink:href="#hex" width="50" height="50" x="445" y="74';
  svgData[42] = '<use xlink:href="#hex" width="50" height="50" x="491" y="74';
  svgData[43] = '<use xlink:href="#hex" width="50" height="50" x="537" y="74';
  svgData[44] = '<use xlink:href="#hex" width="50" height="50" x="583" y="74';
  svgData[45] = '<use xlink:href="#hex" width="50" height="50" x="629" y="74';
  svgData[46] = '<use xlink:href="#hex" width="50" height="50" x="675" y="74';
  svgData[47] = '<use xlink:href="#hex" width="50" height="50" x="721" y="74';
  svgData[48] = '<use xlink:href="#hex" width="50" height="50" x="767" y="74';
  svgData[49] = '<use xlink:href="#hex" width="50" height="50" x="813" y="74';
  svgData[50] = '<use xlink:href="#hex" width="50" height="50" x="859" y="74';
  svgData[51] = '<use xlink:href="#hex" width="50" height="50" x="905" y="74';
  svgData[52] = '<use xlink:href="#hex" width="50" height="50" x="951" y="74';
  svgData[53] = '<use xlink:href="#hex" width="50" height="50" x="997" y="74';
  svgData[54] = '<use xlink:href="#hex" width="50" height="50" x="1043" y="74';
  svgData[55] = '<use xlink:href="#hex" width="50" height="50" x="1089" y="74';
  svgData[56] = '<use xlink:href="#hex" width="50" height="50" x="1135" y="74';
  svgData[57] = '<use xlink:href="#hex" width="50" height="50" x="1181" y="74';
  svgData[58] = '<use xlink:href="#hex" width="50" height="50" x="1227" y="74';
  svgData[59] = '<use xlink:href="#hex" width="50" height="50" x="1273" y="74';
  svgData[60] = '<use xlink:href="#hex" width="50" height="50" x="1319" y="74';
  svgData[61] = '<use xlink:href="#hex" width="50" height="50" x="1365" y="74';
  svgData[62] = '<use xlink:href="#hex" width="50" height="50" x="1411" y="74';
  svgData[63] = '<use xlink:href="#hex" width="50" height="50" x="1457" y="74';
  svgData[64] = '<use xlink:href="#hex" width="50" height="50" x="54" y="114';
  svgData[65] = '<use xlink:href="#hex" width="50" height="50" x="100" y="114';
  svgData[66] = '<use xlink:href="#hex" width="50" height="50" x="146" y="114';
  svgData[67] = '<use xlink:href="#hex" width="50" height="50" x="192" y="114';
  svgData[68] = '<use xlink:href="#hex" width="50" height="50" x="238" y="114';
  svgData[69] = '<use xlink:href="#hex" width="50" height="50" x="284" y="114';
  svgData[70] = '<use xlink:href="#hex" width="50" height="50" x="330" y="114';
  svgData[71] = '<use xlink:href="#hex" width="50" height="50" x="376" y="114';
  svgData[72] = '<use xlink:href="#hex" width="50" height="50" x="422" y="114';
  svgData[73] = '<use xlink:href="#hex" width="50" height="50" x="468" y="114';
  svgData[74] = '<use xlink:href="#hex" width="50" height="50" x="514" y="114';
  svgData[75] = '<use xlink:href="#hex" width="50" height="50" x="560" y="114';
  svgData[76] = '<use xlink:href="#hex" width="50" height="50" x="606" y="114';
  svgData[77] = '<use xlink:href="#hex" width="50" height="50" x="652" y="114';
  svgData[78] = '<use xlink:href="#hex" width="50" height="50" x="698" y="114';
  svgData[79] = '<use xlink:href="#hex" width="50" height="50" x="744" y="114';
  svgData[80] = '<use xlink:href="#hex" width="50" height="50" x="790" y="114';
  svgData[81] = '<use xlink:href="#hex" width="50" height="50" x="836" y="114';
  svgData[82] = '<use xlink:href="#hex" width="50" height="50" x="882" y="114';
  svgData[83] = '<use xlink:href="#hex" width="50" height="50" x="928" y="114';
  svgData[84] = '<use xlink:href="#hex" width="50" height="50" x="974" y="114';
  svgData[85] = '<use xlink:href="#hex" width="50" height="50" x="1020" y="114';
  svgData[86] = '<use xlink:href="#hex" width="50" height="50" x="1066" y="114';
  svgData[87] = '<use xlink:href="#hex" width="50" height="50" x="1112" y="114';
  svgData[88] = '<use xlink:href="#hex" width="50" height="50" x="1158" y="114';
  svgData[89] = '<use xlink:href="#hex" width="50" height="50" x="1204" y="114';
  svgData[90] = '<use xlink:href="#hex" width="50" height="50" x="1250" y="114';
  svgData[91] = '<use xlink:href="#hex" width="50" height="50" x="1296" y="114';
  svgData[92] = '<use xlink:href="#hex" width="50" height="50" x="1342" y="114';
  svgData[93] = '<use xlink:href="#hex" width="50" height="50" x="1388" y="114';
  svgData[94] = '<use xlink:href="#hex" width="50" height="50" x="1434" y="114';
  svgData[95] = '<use xlink:href="#hex" width="50" height="50" x="1480" y="114';
  svgData[96] = '<use xlink:href="#hex" width="50" height="50" x="31" y="154';
  svgData[97] = '<use xlink:href="#hex" width="50" height="50" x="77" y="154';
  svgData[98] = '<use xlink:href="#hex" width="50" height="50" x="123" y="154';
  svgData[99] = '<use xlink:href="#hex" width="50" height="50" x="169" y="154';
  svgData[100] = '<use xlink:href="#hex" width="50" height="50" x="215" y="154';
  svgData[101] = '<use xlink:href="#hex" width="50" height="50" x="261" y="154';
  svgData[102] = '<use xlink:href="#hex" width="50" height="50" x="307" y="154';
  svgData[103] = '<use xlink:href="#hex" width="50" height="50" x="353" y="154';
  svgData[104] = '<use xlink:href="#hex" width="50" height="50" x="399" y="154';
  svgData[105] = '<use xlink:href="#hex" width="50" height="50" x="445" y="154';
  svgData[106] = '<use xlink:href="#hex" width="50" height="50" x="491" y="154';
  svgData[107] = '<use xlink:href="#hex" width="50" height="50" x="537" y="154';
  svgData[108] = '<use xlink:href="#hex" width="50" height="50" x="583" y="154';
  svgData[109] = '<use xlink:href="#hex" width="50" height="50" x="629" y="154';
  svgData[110] = '<use xlink:href="#hex" width="50" height="50" x="675" y="154';
  svgData[111] = '<use xlink:href="#hex" width="50" height="50" x="721" y="154';
  svgData[112] = '<use xlink:href="#hex" width="50" height="50" x="767" y="154';
  svgData[113] = '<use xlink:href="#hex" width="50" height="50" x="813" y="154';
  svgData[114] = '<use xlink:href="#hex" width="50" height="50" x="859" y="154';
  svgData[115] = '<use xlink:href="#hex" width="50" height="50" x="905" y="154';
  svgData[116] = '<use xlink:href="#hex" width="50" height="50" x="951" y="154';
  svgData[117] = '<use xlink:href="#hex" width="50" height="50" x="997" y="154';
  svgData[118] = '<use xlink:href="#hex" width="50" height="50" x="1043" y="154';
  svgData[119] = '<use xlink:href="#hex" width="50" height="50" x="1089" y="154';
  svgData[120] = '<use xlink:href="#hex" width="50" height="50" x="1135" y="154';
  svgData[121] = '<use xlink:href="#hex" width="50" height="50" x="1181" y="154';
  svgData[122] = '<use xlink:href="#hex" width="50" height="50" x="1227" y="154';
  svgData[123] = '<use xlink:href="#hex" width="50" height="50" x="1273" y="154';
  svgData[124] = '<use xlink:href="#hex" width="50" height="50" x="1319" y="154';
  svgData[125] = '<use xlink:href="#hex" width="50" height="50" x="1365" y="154';
  svgData[126] = '<use xlink:href="#hex" width="50" height="50" x="1411" y="154';
  svgData[127] = '<use xlink:href="#hex" width="50" height="50" x="1457" y="154';
  svgData[128] = '<use xlink:href="#hex" width="50" height="50" x="54" y="194';
  svgData[129] = '<use xlink:href="#hex" width="50" height="50" x="100" y="194';
  svgData[130] = '<use xlink:href="#hex" width="50" height="50" x="146" y="194';
  svgData[131] = '<use xlink:href="#hex" width="50" height="50" x="192" y="194';
  svgData[132] = '<use xlink:href="#hex" width="50" height="50" x="238" y="194';
  svgData[133] = '<use xlink:href="#hex" width="50" height="50" x="284" y="194';
  svgData[134] = '<use xlink:href="#hex" width="50" height="50" x="330" y="194';
  svgData[135] = '<use xlink:href="#hex" width="50" height="50" x="376" y="194';
  svgData[136] = '<use xlink:href="#hex" width="50" height="50" x="422" y="194';
  svgData[137] = '<use xlink:href="#hex" width="50" height="50" x="468" y="194';
  svgData[138] = '<use xlink:href="#hex" width="50" height="50" x="514" y="194';
  svgData[139] = '<use xlink:href="#hex" width="50" height="50" x="560" y="194';
  svgData[140] = '<use xlink:href="#hex" width="50" height="50" x="606" y="194';
  svgData[141] = '<use xlink:href="#hex" width="50" height="50" x="652" y="194';
  svgData[142] = '<use xlink:href="#hex" width="50" height="50" x="698" y="194';
  svgData[143] = '<use xlink:href="#hex" width="50" height="50" x="744" y="194';
  svgData[144] = '<use xlink:href="#hex" width="50" height="50" x="790" y="194';
  svgData[145] = '<use xlink:href="#hex" width="50" height="50" x="836" y="194';
  svgData[146] = '<use xlink:href="#hex" width="50" height="50" x="882" y="194';
  svgData[147] = '<use xlink:href="#hex" width="50" height="50" x="928" y="194';
  svgData[148] = '<use xlink:href="#hex" width="50" height="50" x="974" y="194';
  svgData[149] = '<use xlink:href="#hex" width="50" height="50" x="1020" y="194';
  svgData[150] = '<use xlink:href="#hex" width="50" height="50" x="1066" y="194';
  svgData[151] = '<use xlink:href="#hex" width="50" height="50" x="1112" y="194';
  svgData[152] = '<use xlink:href="#hex" width="50" height="50" x="1158" y="194';
  svgData[153] = '<use xlink:href="#hex" width="50" height="50" x="1204" y="194';
  svgData[154] = '<use xlink:href="#hex" width="50" height="50" x="1250" y="194';
  svgData[155] = '<use xlink:href="#hex" width="50" height="50" x="1296" y="194';
  svgData[156] = '<use xlink:href="#hex" width="50" height="50" x="1342" y="194';
  svgData[157] = '<use xlink:href="#hex" width="50" height="50" x="1388" y="194';
  svgData[158] = '<use xlink:href="#hex" width="50" height="50" x="1434" y="194';
  svgData[159] = '<use xlink:href="#hex" width="50" height="50" x="1480" y="194';
  svgData[160] = '<use xlink:href="#hex" width="50" height="50" x="31" y="234';
  svgData[161] = '<use xlink:href="#hex" width="50" height="50" x="77" y="234';
  svgData[162] = '<use xlink:href="#hex" width="50" height="50" x="123" y="234';
  svgData[163] = '<use xlink:href="#hex" width="50" height="50" x="169" y="234';
  svgData[164] = '<use xlink:href="#hex" width="50" height="50" x="215" y="234';
  svgData[165] = '<use xlink:href="#hex" width="50" height="50" x="261" y="234';
  svgData[166] = '<use xlink:href="#hex" width="50" height="50" x="307" y="234';
  svgData[167] = '<use xlink:href="#hex" width="50" height="50" x="353" y="234';
  svgData[168] = '<use xlink:href="#hex" width="50" height="50" x="399" y="234';
  svgData[169] = '<use xlink:href="#hex" width="50" height="50" x="445" y="234';
  svgData[170] = '<use xlink:href="#hex" width="50" height="50" x="491" y="234';
  svgData[171] = '<use xlink:href="#hex" width="50" height="50" x="537" y="234';
  svgData[172] = '<use xlink:href="#hex" width="50" height="50" x="583" y="234';
  svgData[173] = '<use xlink:href="#hex" width="50" height="50" x="629" y="234';
  svgData[174] = '<use xlink:href="#hex" width="50" height="50" x="675" y="234';
  svgData[175] = '<use xlink:href="#hex" width="50" height="50" x="721" y="234';
  svgData[176] = '<use xlink:href="#hex" width="50" height="50" x="767" y="234';
  svgData[177] = '<use xlink:href="#hex" width="50" height="50" x="813" y="234';
  svgData[178] = '<use xlink:href="#hex" width="50" height="50" x="859" y="234';
  svgData[179] = '<use xlink:href="#hex" width="50" height="50" x="905" y="234';
  svgData[180] = '<use xlink:href="#hex" width="50" height="50" x="951" y="234';
  svgData[181] = '<use xlink:href="#hex" width="50" height="50" x="997" y="234';
  svgData[182] = '<use xlink:href="#hex" width="50" height="50" x="1043" y="234';
  svgData[183] = '<use xlink:href="#hex" width="50" height="50" x="1089" y="234';
  svgData[184] = '<use xlink:href="#hex" width="50" height="50" x="1135" y="234';
  svgData[185] = '<use xlink:href="#hex" width="50" height="50" x="1181" y="234';
  svgData[186] = '<use xlink:href="#hex" width="50" height="50" x="1227" y="234';
  svgData[187] = '<use xlink:href="#hex" width="50" height="50" x="1273" y="234';
  svgData[188] = '<use xlink:href="#hex" width="50" height="50" x="1319" y="234';
  svgData[189] = '<use xlink:href="#hex" width="50" height="50" x="1365" y="234';
  svgData[190] = '<use xlink:href="#hex" width="50" height="50" x="1411" y="234';
  svgData[191] = '<use xlink:href="#hex" width="50" height="50" x="1457" y="234';
  svgData[192] = '<use xlink:href="#hex" width="50" height="50" x="54" y="274';
  svgData[193] = '<use xlink:href="#hex" width="50" height="50" x="100" y="274';
  svgData[194] = '<use xlink:href="#hex" width="50" height="50" x="146" y="274';
  svgData[195] = '<use xlink:href="#hex" width="50" height="50" x="192" y="274';
  svgData[196] = '<use xlink:href="#hex" width="50" height="50" x="238" y="274';
  svgData[197] = '<use xlink:href="#hex" width="50" height="50" x="284" y="274';
  svgData[198] = '<use xlink:href="#hex" width="50" height="50" x="330" y="274';
  svgData[199] = '<use xlink:href="#hex" width="50" height="50" x="376" y="274';
  svgData[200] = '<use xlink:href="#hex" width="50" height="50" x="422" y="274';
  svgData[201] = '<use xlink:href="#hex" width="50" height="50" x="468" y="274';
  svgData[202] = '<use xlink:href="#hex" width="50" height="50" x="514" y="274';
  svgData[203] = '<use xlink:href="#hex" width="50" height="50" x="560" y="274';
  svgData[204] = '<use xlink:href="#hex" width="50" height="50" x="606" y="274';
  svgData[205] = '<use xlink:href="#hex" width="50" height="50" x="652" y="274';
  svgData[206] = '<use xlink:href="#hex" width="50" height="50" x="698" y="274';
  svgData[207] = '<use xlink:href="#hex" width="50" height="50" x="744" y="274';
  svgData[208] = '<use xlink:href="#hex" width="50" height="50" x="790" y="274';
  svgData[209] = '<use xlink:href="#hex" width="50" height="50" x="836" y="274';
  svgData[210] = '<use xlink:href="#hex" width="50" height="50" x="882" y="274';
  svgData[211] = '<use xlink:href="#hex" width="50" height="50" x="928" y="274';
  svgData[212] = '<use xlink:href="#hex" width="50" height="50" x="974" y="274';
  svgData[213] = '<use xlink:href="#hex" width="50" height="50" x="1020" y="274';
  svgData[214] = '<use xlink:href="#hex" width="50" height="50" x="1066" y="274';
  svgData[215] = '<use xlink:href="#hex" width="50" height="50" x="1112" y="274';
  svgData[216] = '<use xlink:href="#hex" width="50" height="50" x="1158" y="274';
  svgData[217] = '<use xlink:href="#hex" width="50" height="50" x="1204" y="274';
  svgData[218] = '<use xlink:href="#hex" width="50" height="50" x="1250" y="274';
  svgData[219] = '<use xlink:href="#hex" width="50" height="50" x="1296" y="274';
  svgData[220] = '<use xlink:href="#hex" width="50" height="50" x="1342" y="274';
  svgData[221] = '<use xlink:href="#hex" width="50" height="50" x="1388" y="274';
  svgData[222] = '<use xlink:href="#hex" width="50" height="50" x="1434" y="274';
  svgData[223] = '<use xlink:href="#hex" width="50" height="50" x="1480" y="274';
  svgData[224] = '<use xlink:href="#hex" width="50" height="50" x="31" y="314';
  svgData[225] = '<use xlink:href="#hex" width="50" height="50" x="77" y="314';
  svgData[226] = '<use xlink:href="#hex" width="50" height="50" x="123" y="314';
  svgData[227] = '<use xlink:href="#hex" width="50" height="50" x="169" y="314';
  svgData[228] = '<use xlink:href="#hex" width="50" height="50" x="215" y="314';
  svgData[229] = '<use xlink:href="#hex" width="50" height="50" x="261" y="314';
  svgData[230] = '<use xlink:href="#hex" width="50" height="50" x="307" y="314';
  svgData[231] = '<use xlink:href="#hex" width="50" height="50" x="353" y="314';
  svgData[232] = '<use xlink:href="#hex" width="50" height="50" x="399" y="314';
  svgData[233] = '<use xlink:href="#hex" width="50" height="50" x="445" y="314';
  svgData[234] = '<use xlink:href="#hex" width="50" height="50" x="491" y="314';
  svgData[235] = '<use xlink:href="#hex" width="50" height="50" x="537" y="314';
  svgData[236] = '<use xlink:href="#hex" width="50" height="50" x="583" y="314';
  svgData[237] = '<use xlink:href="#hex" width="50" height="50" x="629" y="314';
  svgData[238] = '<use xlink:href="#hex" width="50" height="50" x="675" y="314';
  svgData[239] = '<use xlink:href="#hex" width="50" height="50" x="721" y="314';
  svgData[240] = '<use xlink:href="#hex" width="50" height="50" x="767" y="314';
  svgData[241] = '<use xlink:href="#hex" width="50" height="50" x="813" y="314';
  svgData[242] = '<use xlink:href="#hex" width="50" height="50" x="859" y="314';
  svgData[243] = '<use xlink:href="#hex" width="50" height="50" x="905" y="314';
  svgData[244] = '<use xlink:href="#hex" width="50" height="50" x="951" y="314';
  svgData[245] = '<use xlink:href="#hex" width="50" height="50" x="997" y="314';
  svgData[246] = '<use xlink:href="#hex" width="50" height="50" x="1043" y="314';
  svgData[247] = '<use xlink:href="#hex" width="50" height="50" x="1089" y="314';
  svgData[248] = '<use xlink:href="#hex" width="50" height="50" x="1135" y="314';
  svgData[249] = '<use xlink:href="#hex" width="50" height="50" x="1181" y="314';
  svgData[250] = '<use xlink:href="#hex" width="50" height="50" x="1227" y="314';
  svgData[251] = '<use xlink:href="#hex" width="50" height="50" x="1273" y="314';
  svgData[252] = '<use xlink:href="#hex" width="50" height="50" x="1319" y="314';
  svgData[253] = '<use xlink:href="#hex" width="50" height="50" x="1365" y="314';
  svgData[254] = '<use xlink:href="#hex" width="50" height="50" x="1411" y="314';
  svgData[255] = '<use xlink:href="#hex" width="50" height="50" x="1457" y="314';
  svgData[256] = '<use xlink:href="#hex" width="50" height="50" x="54" y="354';
  svgData[257] = '<use xlink:href="#hex" width="50" height="50" x="100" y="354';
  svgData[258] = '<use xlink:href="#hex" width="50" height="50" x="146" y="354';
  svgData[259] = '<use xlink:href="#hex" width="50" height="50" x="192" y="354';
  svgData[260] = '<use xlink:href="#hex" width="50" height="50" x="238" y="354';
  svgData[261] = '<use xlink:href="#hex" width="50" height="50" x="284" y="354';
  svgData[262] = '<use xlink:href="#hex" width="50" height="50" x="330" y="354';
  svgData[263] = '<use xlink:href="#hex" width="50" height="50" x="376" y="354';
  svgData[264] = '<use xlink:href="#hex" width="50" height="50" x="422" y="354';
  svgData[265] = '<use xlink:href="#hex" width="50" height="50" x="468" y="354';
  svgData[266] = '<use xlink:href="#hex" width="50" height="50" x="514" y="354';
  svgData[267] = '<use xlink:href="#hex" width="50" height="50" x="560" y="354';
  svgData[268] = '<use xlink:href="#hex" width="50" height="50" x="606" y="354';
  svgData[269] = '<use xlink:href="#hex" width="50" height="50" x="652" y="354';
  svgData[270] = '<use xlink:href="#hex" width="50" height="50" x="698" y="354';
  svgData[271] = '<use xlink:href="#hex" width="50" height="50" x="744" y="354';
  svgData[272] = '<use xlink:href="#hex" width="50" height="50" x="790" y="354';
  svgData[273] = '<use xlink:href="#hex" width="50" height="50" x="836" y="354';
  svgData[274] = '<use xlink:href="#hex" width="50" height="50" x="882" y="354';
  svgData[275] = '<use xlink:href="#hex" width="50" height="50" x="928" y="354';
  svgData[276] = '<use xlink:href="#hex" width="50" height="50" x="974" y="354';
  svgData[277] = '<use xlink:href="#hex" width="50" height="50" x="1020" y="354';
  svgData[278] = '<use xlink:href="#hex" width="50" height="50" x="1066" y="354';
  svgData[279] = '<use xlink:href="#hex" width="50" height="50" x="1112" y="354';
  svgData[280] = '<use xlink:href="#hex" width="50" height="50" x="1158" y="354';
  svgData[281] = '<use xlink:href="#hex" width="50" height="50" x="1204" y="354';
  svgData[282] = '<use xlink:href="#hex" width="50" height="50" x="1250" y="354';
  svgData[283] = '<use xlink:href="#hex" width="50" height="50" x="1296" y="354';
  svgData[284] = '<use xlink:href="#hex" width="50" height="50" x="1342" y="354';
  svgData[285] = '<use xlink:href="#hex" width="50" height="50" x="1388" y="354';
  svgData[286] = '<use xlink:href="#hex" width="50" height="50" x="1434" y="354';
  svgData[287] = '<use xlink:href="#hex" width="50" height="50" x="1480" y="354';
  svgData[288] = '<use xlink:href="#hex" width="50" height="50" x="31" y="394';
  svgData[289] = '<use xlink:href="#hex" width="50" height="50" x="77" y="394';
  svgData[290] = '<use xlink:href="#hex" width="50" height="50" x="123" y="394';
  svgData[291] = '<use xlink:href="#hex" width="50" height="50" x="169" y="394';
  svgData[292] = '<use xlink:href="#hex" width="50" height="50" x="215" y="394';
  svgData[293] = '<use xlink:href="#hex" width="50" height="50" x="261" y="394';
  svgData[294] = '<use xlink:href="#hex" width="50" height="50" x="307" y="394';
  svgData[295] = '<use xlink:href="#hex" width="50" height="50" x="353" y="394';
  svgData[296] = '<use xlink:href="#hex" width="50" height="50" x="399" y="394';
  svgData[297] = '<use xlink:href="#hex" width="50" height="50" x="445" y="394';
  svgData[298] = '<use xlink:href="#hex" width="50" height="50" x="491" y="394';
  svgData[299] = '<use xlink:href="#hex" width="50" height="50" x="537" y="394';
  svgData[300] = '<use xlink:href="#hex" width="50" height="50" x="583" y="394';
  svgData[301] = '<use xlink:href="#hex" width="50" height="50" x="629" y="394';
  svgData[302] = '<use xlink:href="#hex" width="50" height="50" x="675" y="394';
  svgData[303] = '<use xlink:href="#hex" width="50" height="50" x="721" y="394';
  svgData[304] = '<use xlink:href="#hex" width="50" height="50" x="767" y="394';
  svgData[305] = '<use xlink:href="#hex" width="50" height="50" x="813" y="394';
  svgData[306] = '<use xlink:href="#hex" width="50" height="50" x="859" y="394';
  svgData[307] = '<use xlink:href="#hex" width="50" height="50" x="905" y="394';
  svgData[308] = '<use xlink:href="#hex" width="50" height="50" x="951" y="394';
  svgData[309] = '<use xlink:href="#hex" width="50" height="50" x="997" y="394';
  svgData[310] = '<use xlink:href="#hex" width="50" height="50" x="1043" y="394';
  svgData[311] = '<use xlink:href="#hex" width="50" height="50" x="1089" y="394';
  svgData[312] = '<use xlink:href="#hex" width="50" height="50" x="1135" y="394';
  svgData[313] = '<use xlink:href="#hex" width="50" height="50" x="1181" y="394';
  svgData[314] = '<use xlink:href="#hex" width="50" height="50" x="1227" y="394';
  svgData[315] = '<use xlink:href="#hex" width="50" height="50" x="1273" y="394';
  svgData[316] = '<use xlink:href="#hex" width="50" height="50" x="1319" y="394';
  svgData[317] = '<use xlink:href="#hex" width="50" height="50" x="1365" y="394';
  svgData[318] = '<use xlink:href="#hex" width="50" height="50" x="1411" y="394';
  svgData[319] = '<use xlink:href="#hex" width="50" height="50" x="1457" y="394';
  svgData[320] = '<use xlink:href="#hex" width="50" height="50" x="54" y="434';
  svgData[321] = '<use xlink:href="#hex" width="50" height="50" x="100" y="434';
  svgData[322] = '<use xlink:href="#hex" width="50" height="50" x="146" y="434';
  svgData[323] = '<use xlink:href="#hex" width="50" height="50" x="192" y="434';
  svgData[324] = '<use xlink:href="#hex" width="50" height="50" x="238" y="434';
  svgData[325] = '<use xlink:href="#hex" width="50" height="50" x="284" y="434';
  svgData[326] = '<use xlink:href="#hex" width="50" height="50" x="330" y="434';
  svgData[327] = '<use xlink:href="#hex" width="50" height="50" x="376" y="434';
  svgData[328] = '<use xlink:href="#hex" width="50" height="50" x="422" y="434';
  svgData[329] = '<use xlink:href="#hex" width="50" height="50" x="468" y="434';
  svgData[330] = '<use xlink:href="#hex" width="50" height="50" x="514" y="434';
  svgData[331] = '<use xlink:href="#hex" width="50" height="50" x="560" y="434';
  svgData[332] = '<use xlink:href="#hex" width="50" height="50" x="606" y="434';
  svgData[333] = '<use xlink:href="#hex" width="50" height="50" x="652" y="434';
  svgData[334] = '<use xlink:href="#hex" width="50" height="50" x="698" y="434';
  svgData[335] = '<use xlink:href="#hex" width="50" height="50" x="744" y="434';
  svgData[336] = '<use xlink:href="#hex" width="50" height="50" x="790" y="434';
  svgData[337] = '<use xlink:href="#hex" width="50" height="50" x="836" y="434';
  svgData[338] = '<use xlink:href="#hex" width="50" height="50" x="882" y="434';
  svgData[339] = '<use xlink:href="#hex" width="50" height="50" x="928" y="434';
  svgData[340] = '<use xlink:href="#hex" width="50" height="50" x="974" y="434';
  svgData[341] = '<use xlink:href="#hex" width="50" height="50" x="1020" y="434';
  svgData[342] = '<use xlink:href="#hex" width="50" height="50" x="1066" y="434';
  svgData[343] = '<use xlink:href="#hex" width="50" height="50" x="1112" y="434';
  svgData[344] = '<use xlink:href="#hex" width="50" height="50" x="1158" y="434';
  svgData[345] = '<use xlink:href="#hex" width="50" height="50" x="1204" y="434';
  svgData[346] = '<use xlink:href="#hex" width="50" height="50" x="1250" y="434';
  svgData[347] = '<use xlink:href="#hex" width="50" height="50" x="1296" y="434';
  svgData[348] = '<use xlink:href="#hex" width="50" height="50" x="1342" y="434';
  svgData[349] = '<use xlink:href="#hex" width="50" height="50" x="1388" y="434';
  svgData[350] = '<use xlink:href="#hex" width="50" height="50" x="1434" y="434';
  svgData[351] = '<use xlink:href="#hex" width="50" height="50" x="1480" y="434';
  svgData[352] = '<use xlink:href="#hex" width="50" height="50" x="31" y="474';
  svgData[353] = '<use xlink:href="#hex" width="50" height="50" x="77" y="474';
  svgData[354] = '<use xlink:href="#hex" width="50" height="50" x="123" y="474';
  svgData[355] = '<use xlink:href="#hex" width="50" height="50" x="169" y="474';
  svgData[356] = '<use xlink:href="#hex" width="50" height="50" x="215" y="474';
  svgData[357] = '<use xlink:href="#hex" width="50" height="50" x="261" y="474';
  svgData[358] = '<use xlink:href="#hex" width="50" height="50" x="307" y="474';
  svgData[359] = '<use xlink:href="#hex" width="50" height="50" x="353" y="474';
  svgData[360] = '<use xlink:href="#hex" width="50" height="50" x="399" y="474';
  svgData[361] = '<use xlink:href="#hex" width="50" height="50" x="445" y="474';
  svgData[362] = '<use xlink:href="#hex" width="50" height="50" x="491" y="474';
  svgData[363] = '<use xlink:href="#hex" width="50" height="50" x="537" y="474';
  svgData[364] = '<use xlink:href="#hex" width="50" height="50" x="583" y="474';
  svgData[365] = '<use xlink:href="#hex" width="50" height="50" x="629" y="474';
  svgData[366] = '<use xlink:href="#hex" width="50" height="50" x="675" y="474';
  svgData[367] = '<use xlink:href="#hex" width="50" height="50" x="721" y="474';
  svgData[368] = '<use xlink:href="#hex" width="50" height="50" x="767" y="474';
  svgData[369] = '<use xlink:href="#hex" width="50" height="50" x="813" y="474';
  svgData[370] = '<use xlink:href="#hex" width="50" height="50" x="859" y="474';
  svgData[371] = '<use xlink:href="#hex" width="50" height="50" x="905" y="474';
  svgData[372] = '<use xlink:href="#hex" width="50" height="50" x="951" y="474';
  svgData[373] = '<use xlink:href="#hex" width="50" height="50" x="997" y="474';
  svgData[374] = '<use xlink:href="#hex" width="50" height="50" x="1043" y="474';
  svgData[375] = '<use xlink:href="#hex" width="50" height="50" x="1089" y="474';
  svgData[376] = '<use xlink:href="#hex" width="50" height="50" x="1135" y="474';
  svgData[377] = '<use xlink:href="#hex" width="50" height="50" x="1181" y="474';
  svgData[378] = '<use xlink:href="#hex" width="50" height="50" x="1227" y="474';
  svgData[379] = '<use xlink:href="#hex" width="50" height="50" x="1273" y="474';
  svgData[380] = '<use xlink:href="#hex" width="50" height="50" x="1319" y="474';
  svgData[381] = '<use xlink:href="#hex" width="50" height="50" x="1365" y="474';
  svgData[382] = '<use xlink:href="#hex" width="50" height="50" x="1411" y="474';
  svgData[383] = '<use xlink:href="#hex" width="50" height="50" x="1457" y="474';
  svgData[384] = '<use xlink:href="#hex" width="50" height="50" x="54" y="514';
  svgData[385] = '<use xlink:href="#hex" width="50" height="50" x="100" y="514';
  svgData[386] = '<use xlink:href="#hex" width="50" height="50" x="146" y="514';
  svgData[387] = '<use xlink:href="#hex" width="50" height="50" x="192" y="514';
  svgData[388] = '<use xlink:href="#hex" width="50" height="50" x="238" y="514';
  svgData[389] = '<use xlink:href="#hex" width="50" height="50" x="284" y="514';
  svgData[390] = '<use xlink:href="#hex" width="50" height="50" x="330" y="514';
  svgData[391] = '<use xlink:href="#hex" width="50" height="50" x="376" y="514';
  svgData[392] = '<use xlink:href="#hex" width="50" height="50" x="422" y="514';
  svgData[393] = '<use xlink:href="#hex" width="50" height="50" x="468" y="514';
  svgData[394] = '<use xlink:href="#hex" width="50" height="50" x="514" y="514';
  svgData[395] = '<use xlink:href="#hex" width="50" height="50" x="560" y="514';
  svgData[396] = '<use xlink:href="#hex" width="50" height="50" x="606" y="514';
  svgData[397] = '<use xlink:href="#hex" width="50" height="50" x="652" y="514';
  svgData[398] = '<use xlink:href="#hex" width="50" height="50" x="698" y="514';
  svgData[399] = '<use xlink:href="#hex" width="50" height="50" x="744" y="514';
  svgData[400] = '<use xlink:href="#hex" width="50" height="50" x="790" y="514';
  svgData[401] = '<use xlink:href="#hex" width="50" height="50" x="836" y="514';
  svgData[402] = '<use xlink:href="#hex" width="50" height="50" x="882" y="514';
  svgData[403] = '<use xlink:href="#hex" width="50" height="50" x="928" y="514';
  svgData[404] = '<use xlink:href="#hex" width="50" height="50" x="974" y="514';
  svgData[405] = '<use xlink:href="#hex" width="50" height="50" x="1020" y="514';
  svgData[406] = '<use xlink:href="#hex" width="50" height="50" x="1066" y="514';
  svgData[407] = '<use xlink:href="#hex" width="50" height="50" x="1112" y="514';
  svgData[408] = '<use xlink:href="#hex" width="50" height="50" x="1158" y="514';
  svgData[409] = '<use xlink:href="#hex" width="50" height="50" x="1204" y="514';
  svgData[410] = '<use xlink:href="#hex" width="50" height="50" x="1250" y="514';
  svgData[411] = '<use xlink:href="#hex" width="50" height="50" x="1296" y="514';
  svgData[412] = '<use xlink:href="#hex" width="50" height="50" x="1342" y="514';
  svgData[413] = '<use xlink:href="#hex" width="50" height="50" x="1388" y="514';
  svgData[414] = '<use xlink:href="#hex" width="50" height="50" x="1434" y="514';
  svgData[415] = '<use xlink:href="#hex" width="50" height="50" x="1480" y="514';
  svgData[416] = '<use xlink:href="#hex" width="50" height="50" x="31" y="554';
  svgData[417] = '<use xlink:href="#hex" width="50" height="50" x="77" y="554';
  svgData[418] = '<use xlink:href="#hex" width="50" height="50" x="123" y="554';
  svgData[419] = '<use xlink:href="#hex" width="50" height="50" x="169" y="554';
  svgData[420] = '<use xlink:href="#hex" width="50" height="50" x="215" y="554';
  svgData[421] = '<use xlink:href="#hex" width="50" height="50" x="261" y="554';
  svgData[422] = '<use xlink:href="#hex" width="50" height="50" x="307" y="554';
  svgData[423] = '<use xlink:href="#hex" width="50" height="50" x="353" y="554';
  svgData[424] = '<use xlink:href="#hex" width="50" height="50" x="399" y="554';
  svgData[425] = '<use xlink:href="#hex" width="50" height="50" x="445" y="554';
  svgData[426] = '<use xlink:href="#hex" width="50" height="50" x="491" y="554';
  svgData[427] = '<use xlink:href="#hex" width="50" height="50" x="537" y="554';
  svgData[428] = '<use xlink:href="#hex" width="50" height="50" x="583" y="554';
  svgData[429] = '<use xlink:href="#hex" width="50" height="50" x="629" y="554';
  svgData[430] = '<use xlink:href="#hex" width="50" height="50" x="675" y="554';
  svgData[431] = '<use xlink:href="#hex" width="50" height="50" x="721" y="554';
  svgData[432] = '<use xlink:href="#hex" width="50" height="50" x="767" y="554';
  svgData[433] = '<use xlink:href="#hex" width="50" height="50" x="813" y="554';
  svgData[434] = '<use xlink:href="#hex" width="50" height="50" x="859" y="554';
  svgData[435] = '<use xlink:href="#hex" width="50" height="50" x="905" y="554';
  svgData[436] = '<use xlink:href="#hex" width="50" height="50" x="951" y="554';
  svgData[437] = '<use xlink:href="#hex" width="50" height="50" x="997" y="554';
  svgData[438] = '<use xlink:href="#hex" width="50" height="50" x="1043" y="554';
  svgData[439] = '<use xlink:href="#hex" width="50" height="50" x="1089" y="554';
  svgData[440] = '<use xlink:href="#hex" width="50" height="50" x="1135" y="554';
  svgData[441] = '<use xlink:href="#hex" width="50" height="50" x="1181" y="554';
  svgData[442] = '<use xlink:href="#hex" width="50" height="50" x="1227" y="554';
  svgData[443] = '<use xlink:href="#hex" width="50" height="50" x="1273" y="554';
  svgData[444] = '<use xlink:href="#hex" width="50" height="50" x="1319" y="554';
  svgData[445] = '<use xlink:href="#hex" width="50" height="50" x="1365" y="554';
  svgData[446] = '<use xlink:href="#hex" width="50" height="50" x="1411" y="554';
  svgData[447] = '<use xlink:href="#hex" width="50" height="50" x="1457" y="554';
  svgData[448] = '<use xlink:href="#hex" width="50" height="50" x="54" y="594';
  svgData[449] = '<use xlink:href="#hex" width="50" height="50" x="100" y="594';
  svgData[450] = '<use xlink:href="#hex" width="50" height="50" x="146" y="594';
  svgData[451] = '<use xlink:href="#hex" width="50" height="50" x="192" y="594';
  svgData[452] = '<use xlink:href="#hex" width="50" height="50" x="238" y="594';
  svgData[453] = '<use xlink:href="#hex" width="50" height="50" x="284" y="594';
  svgData[454] = '<use xlink:href="#hex" width="50" height="50" x="330" y="594';
  svgData[455] = '<use xlink:href="#hex" width="50" height="50" x="376" y="594';
  svgData[456] = '<use xlink:href="#hex" width="50" height="50" x="422" y="594';
  svgData[457] = '<use xlink:href="#hex" width="50" height="50" x="468" y="594';
  svgData[458] = '<use xlink:href="#hex" width="50" height="50" x="514" y="594';
  svgData[459] = '<use xlink:href="#hex" width="50" height="50" x="560" y="594';
  svgData[460] = '<use xlink:href="#hex" width="50" height="50" x="606" y="594';
  svgData[461] = '<use xlink:href="#hex" width="50" height="50" x="652" y="594';
  svgData[462] = '<use xlink:href="#hex" width="50" height="50" x="698" y="594';
  svgData[463] = '<use xlink:href="#hex" width="50" height="50" x="744" y="594';
  svgData[464] = '<use xlink:href="#hex" width="50" height="50" x="790" y="594';
  svgData[465] = '<use xlink:href="#hex" width="50" height="50" x="836" y="594';
  svgData[466] = '<use xlink:href="#hex" width="50" height="50" x="882" y="594';
  svgData[467] = '<use xlink:href="#hex" width="50" height="50" x="928" y="594';
  svgData[468] = '<use xlink:href="#hex" width="50" height="50" x="974" y="594';
  svgData[469] = '<use xlink:href="#hex" width="50" height="50" x="1020" y="594';
  svgData[470] = '<use xlink:href="#hex" width="50" height="50" x="1066" y="594';
  svgData[471] = '<use xlink:href="#hex" width="50" height="50" x="1112" y="594';
  svgData[472] = '<use xlink:href="#hex" width="50" height="50" x="1158" y="594';
  svgData[473] = '<use xlink:href="#hex" width="50" height="50" x="1204" y="594';
  svgData[474] = '<use xlink:href="#hex" width="50" height="50" x="1250" y="594';
  svgData[475] = '<use xlink:href="#hex" width="50" height="50" x="1296" y="594';
  svgData[476] = '<use xlink:href="#hex" width="50" height="50" x="1342" y="594';
  svgData[477] = '<use xlink:href="#hex" width="50" height="50" x="1388" y="594';
  svgData[478] = '<use xlink:href="#hex" width="50" height="50" x="1434" y="594';
  svgData[479] = '<use xlink:href="#hex" width="50" height="50" x="1480" y="594';
  svgData[480] = '<use xlink:href="#hex" width="50" height="50" x="31" y="634';
  svgData[481] = '<use xlink:href="#hex" width="50" height="50" x="77" y="634';
  svgData[482] = '<use xlink:href="#hex" width="50" height="50" x="123" y="634';
  svgData[483] = '<use xlink:href="#hex" width="50" height="50" x="169" y="634';
  svgData[484] = '<use xlink:href="#hex" width="50" height="50" x="215" y="634';
  svgData[485] = '<use xlink:href="#hex" width="50" height="50" x="261" y="634';
  svgData[486] = '<use xlink:href="#hex" width="50" height="50" x="307" y="634';
  svgData[487] = '<use xlink:href="#hex" width="50" height="50" x="353" y="634';
  svgData[488] = '<use xlink:href="#hex" width="50" height="50" x="399" y="634';
  svgData[489] = '<use xlink:href="#hex" width="50" height="50" x="445" y="634';
  svgData[490] = '<use xlink:href="#hex" width="50" height="50" x="491" y="634';
  svgData[491] = '<use xlink:href="#hex" width="50" height="50" x="537" y="634';
  svgData[492] = '<use xlink:href="#hex" width="50" height="50" x="583" y="634';
  svgData[493] = '<use xlink:href="#hex" width="50" height="50" x="629" y="634';
  svgData[494] = '<use xlink:href="#hex" width="50" height="50" x="675" y="634';
  svgData[495] = '<use xlink:href="#hex" width="50" height="50" x="721" y="634';
  svgData[496] = '<use xlink:href="#hex" width="50" height="50" x="767" y="634';
  svgData[497] = '<use xlink:href="#hex" width="50" height="50" x="813" y="634';
  svgData[498] = '<use xlink:href="#hex" width="50" height="50" x="859" y="634';
  svgData[499] = '<use xlink:href="#hex" width="50" height="50" x="905" y="634';
  svgData[500] = '<use xlink:href="#hex" width="50" height="50" x="951" y="634';
  svgData[501] = '<use xlink:href="#hex" width="50" height="50" x="997" y="634';
  svgData[502] = '<use xlink:href="#hex" width="50" height="50" x="1043" y="634';
  svgData[503] = '<use xlink:href="#hex" width="50" height="50" x="1089" y="634';
  svgData[504] = '<use xlink:href="#hex" width="50" height="50" x="1135" y="634';
  svgData[505] = '<use xlink:href="#hex" width="50" height="50" x="1181" y="634';
  svgData[506] = '<use xlink:href="#hex" width="50" height="50" x="1227" y="634';
  svgData[507] = '<use xlink:href="#hex" width="50" height="50" x="1273" y="634';
  svgData[508] = '<use xlink:href="#hex" width="50" height="50" x="1319" y="634';
  svgData[509] = '<use xlink:href="#hex" width="50" height="50" x="1365" y="634';
  svgData[510] = '<use xlink:href="#hex" width="50" height="50" x="1411" y="634';
  svgData[511] = '<use xlink:href="#hex" width="50" height="50" x="1457" y="634';






  var svgBackgroundColor = {};
  svgBackgroundColor[0] = '#800000"/>';
  svgBackgroundColor[1] = '#8B0000"/>';
  svgBackgroundColor[2] = '#A52A2A"/>';
  svgBackgroundColor[3] = '#B22222"/>';
  svgBackgroundColor[4] = '#DC143C"/>';
  svgBackgroundColor[5] = '#FF0000"/>';
  svgBackgroundColor[6] = '#FF6347"/>';
  svgBackgroundColor[7] = '#FF7F50"/>';
  svgBackgroundColor[8] = '#CD5C5C"/>';
  svgBackgroundColor[9] = '#F08080"/>';
  svgBackgroundColor[10] = '#E9967A"/>';
  svgBackgroundColor[11] = '#FA8072"/>';
  svgBackgroundColor[12] = '#FFA07A"/>';
  svgBackgroundColor[13] = '#FF4500"/>';
  svgBackgroundColor[14] = '#FF8C00"/>';
  svgBackgroundColor[15] = '#FFA500"/>';
  svgBackgroundColor[16] = '#FFD700"/>';
  svgBackgroundColor[17] = '#B8860B"/>';
  svgBackgroundColor[18] = '#DAA520"/>';
  svgBackgroundColor[19] = '#EEE8AA"/>';
  svgBackgroundColor[20] = '#BDB76B"/>';
  svgBackgroundColor[21] = '#F0E68C"/>';
  svgBackgroundColor[22] = '#808000"/>';
  svgBackgroundColor[23] = '#FFFF00"/>';
  svgBackgroundColor[24] = '#9ACD32"/>';
  svgBackgroundColor[25] = '#556B2F"/>';
  svgBackgroundColor[26] = '#6B8E23"/>';
  svgBackgroundColor[27] = '#7CFC00"/>';
  svgBackgroundColor[28] = '#7FFF00"/>';
  svgBackgroundColor[29] = '#ADFF2F"/>';
  svgBackgroundColor[30] = '#006400"/>';
  svgBackgroundColor[31] = '#008000"/>';
  svgBackgroundColor[32] = '#228B22"/>';
  svgBackgroundColor[33] = '#00FF00"/>';
  svgBackgroundColor[34] = '#32CD32"/>';
  svgBackgroundColor[35] = '#90EE90"/>';
  svgBackgroundColor[36] = '#98FB98"/>';
  svgBackgroundColor[37] = '#8FBC8F"/>';
  svgBackgroundColor[38] = '#00FA9A"/>';
  svgBackgroundColor[39] = '#00FF7F"/>';
  svgBackgroundColor[40] = '#2E8B57"/>';
  svgBackgroundColor[41] = '#66CDAA"/>';
  svgBackgroundColor[42] = '#3CB371"/>';
  svgBackgroundColor[43] = '#20B2AA"/>';
  svgBackgroundColor[44] = '#2F4F4F"/>';
  svgBackgroundColor[45] = '#008080"/>';
  svgBackgroundColor[46] = '#008B8B"/>';
  svgBackgroundColor[47] = '#00FFFF"/>';
  svgBackgroundColor[48] = '#00FFFF"/>';
  svgBackgroundColor[49] = '#E0FFFF"/>';
  svgBackgroundColor[50] = '#00CED1"/>';
  svgBackgroundColor[51] = '#40E0D0"/>';
  svgBackgroundColor[52] = '#48D1CC"/>';
  svgBackgroundColor[53] = '#AFEEEE"/>';
  svgBackgroundColor[54] = '#7FFFD4"/>';
  svgBackgroundColor[55] = '#B0E0E6"/>';
  svgBackgroundColor[56] = '#5F9EA0"/>';
  svgBackgroundColor[57] = '#4682B4"/>';
  svgBackgroundColor[58] = '#6495ED"/>';
  svgBackgroundColor[59] = '#00BFFF"/>';
  svgBackgroundColor[60] = '#1E90FF"/>';
  svgBackgroundColor[61] = '#ADD8E6"/>';
  svgBackgroundColor[62] = '#87CEEB"/>';
  svgBackgroundColor[63] = '#87CEFA"/>';
  svgBackgroundColor[64] = '#191970"/>';
  svgBackgroundColor[65] = '#000080"/>';
  svgBackgroundColor[66] = '#00008B"/>';
  svgBackgroundColor[67] = '#0000CD"/>';
  svgBackgroundColor[68] = '#0000FF"/>';
  svgBackgroundColor[69] = '#4169E1"/>';
  svgBackgroundColor[70] = '#8A2BE2"/>';
  svgBackgroundColor[71] = '#4B0082"/>';
  svgBackgroundColor[72] = '#483D8B"/>';
  svgBackgroundColor[73] = '#6A5ACD"/>';
  svgBackgroundColor[74] = '#7B68EE"/>';
  svgBackgroundColor[75] = '#9370DB"/>';
  svgBackgroundColor[76] = '#8B008B"/>';
  svgBackgroundColor[77] = '#9400D3"/>';
  svgBackgroundColor[78] = '#9932CC"/>';
  svgBackgroundColor[79] = '#BA55D3"/>';
  svgBackgroundColor[80] = '#800080"/>';
  svgBackgroundColor[81] = '#D8BFD8"/>';
  svgBackgroundColor[82] = '#DDA0DD"/>';
  svgBackgroundColor[83] = '#EE82EE"/>';
  svgBackgroundColor[84] = '#FF00FF"/>';
  svgBackgroundColor[85] = '#DA70D6"/>';
  svgBackgroundColor[86] = '#C71585"/>';
  svgBackgroundColor[87] = '#DB7093"/>';
  svgBackgroundColor[88] = '#FF1493"/>';
  svgBackgroundColor[89] = '#FF69B4"/>';
  svgBackgroundColor[90] = '#FFB6C1"/>';
  svgBackgroundColor[91] = '#FFC0CB"/>';
  svgBackgroundColor[92] = '#FAEBD7"/>';
  svgBackgroundColor[93] = '#F5F5DC"/>';
  svgBackgroundColor[94] = '#FFE4C4"/>';
  svgBackgroundColor[95] = '#FFEBCD"/>';
  svgBackgroundColor[96] = '#F5DEB3"/>';
  svgBackgroundColor[97] = '#FFF8DC"/>';
  svgBackgroundColor[98] = '#FFFACD"/>';
  svgBackgroundColor[99] = '#FAFAD2"/>';
  svgBackgroundColor[100] = '#FFFFE0"/>';
  svgBackgroundColor[101] = '#8B4513"/>';
  svgBackgroundColor[102] = '#A0522D"/>';
  svgBackgroundColor[103] = '#D2691E"/>';
  svgBackgroundColor[104] = '#CD853F"/>';
  svgBackgroundColor[105] = '#F4A460"/>';
  svgBackgroundColor[106] = '#DEB887"/>';
  svgBackgroundColor[107] = '#D2B48C"/>';
  svgBackgroundColor[108] = '#BC8F8F"/>';
  svgBackgroundColor[109] = '#FFE4B5"/>';
  svgBackgroundColor[110] = '#FFDEAD"/>';
  svgBackgroundColor[111] = '#FFDAB9"/>';
  svgBackgroundColor[112] = '#FFE4E1"/>';
  svgBackgroundColor[113] = '#FFF0F5"/>';
  svgBackgroundColor[114] = '#FAF0E6"/>';
  svgBackgroundColor[115] = '#FDF5E6"/>';
  svgBackgroundColor[116] = '#FFEFD5"/>';
  svgBackgroundColor[117] = '#FFF5EE"/>';
  svgBackgroundColor[118] = '#F5FFFA"/>';
  svgBackgroundColor[119] = '#708090"/>';
  svgBackgroundColor[120] = '#778899"/>';
  svgBackgroundColor[121] = '#B0C4DE"/>';
  svgBackgroundColor[122] = '#E6E6FA"/>';
  svgBackgroundColor[123] = '#FFFAF0"/>';
  svgBackgroundColor[124] = '#F0F8FF"/>';
  svgBackgroundColor[125] = '#F8F8FF"/>';
  svgBackgroundColor[126] = '#F0FFF0"/>';
  svgBackgroundColor[127] = '#FFFFF0"/>';
  svgBackgroundColor[128] = '#F0FFFF"/>';
  svgBackgroundColor[129] = '#FFFAFA"/>';
  svgBackgroundColor[130] = '#000000"/>';
  svgBackgroundColor[131] = '#696969"/>';
  svgBackgroundColor[132] = '#808080"/>';
  svgBackgroundColor[133] = '#A9A9A9"/>';
  svgBackgroundColor[134] = '#C0C0C0"/>';
  svgBackgroundColor[135] = '#D3D3D3"/>';
  svgBackgroundColor[136] = '#DCDCDC"/>';
  svgBackgroundColor[137] = '#FFFFFF"/>';


  let submitCustom = async (_tokenID) => {
    /* global BigInt */


    let tempPeices1 = peices.slice(0,256)
    let tempPeices2 = peices.slice(256, 512)

    let data1 = BigInt('0b'+tempPeices1.join("").toString())
    let data2 = BigInt('0b'+tempPeices2.join("").toString())

    let tempColorOne1 = color1.slice(0,256)
    let tempColorOne2 = color1.slice(256, 512)
    let colorOne1 = BigInt('0b'+tempColorOne1.join("").toString())
    let colorOne2 = BigInt('0b'+tempColorOne2.join("").toString())

    let tempColorTwo1 = color2.slice(0,256)
    let tempColorTwo2 = color2.slice(256, 512)

    let colorTwo1 = BigInt('0b'+tempColorTwo1.join("").toString())
    let colorTwo2 = BigInt('0b'+tempColorTwo2.join("").toString())

    // await metakays.methods.kustomize()
        // await metakays.methods.kustomize(data1, data2, [colorOne1, colorOne2, colorTwo1, colorTwo2], four_colors, tokenID).send({
        //   from: userAccount,

        //   })
        setMsg1("Head to https://arbiscan.io/address/0x7e79c121a912ebebb63af676b4f277fb1701970b#writeContract and connect your ARBITRUM wallet. Scroll down to the *kustomize* function and input these values:")
        setMsg2("_data1: "+String(data1))
        setMsg3("_data2: "+String(data2))
        setMsg4("_colors: "+String(colorOne1)+','+String(colorOne2)+','+String(colorTwo1)+','+String(colorTwo2))
        setMsg5("_colorSelectors: "+String(four_colors[0])+','+String(four_colors[1])+','+String(four_colors[2])+','+String(four_colors[3]))
        setMsg6("_itemID: YOUR_TOKEN_ID")
        }


  const handleShow = async (_value) => {
    setCustomChooser(_value)
    if (showKustomModal) {
      setKustomModal(false)
    } else {
      setKustomModal(true)
    }
  };

  return (
        <div className="Custom">
        {/* backgroundColor */}
        {showKustomModal ?
          <div className="CustomSVGRightSide">
            <div className='over'><CustomIndividualARB/></div>
            <div className="CustomHeader">MENU</div>
            <Link to='/kustomarbmenu' className="itemDropKustomETH">BACK</Link>
            <div className="instructions">BETTER UI/UX IS ON THE WAY. UNTIL THEN, KUSTOMIZE ON ABRITRUM BY HEADING TO https://arbiscan.io/address/0x7e79c121a912ebebb63af676b4f277fb1701970b AND INTERACT DIRECTLY WITH THE CONTRACT.</div>
          <div className="instructions">WE HAVE NO CONTROL OVER ARBISCAN AND ARE NOT LIABLE FOR ANY FAILED/INCORRECT TRANSACTIONS.</div>
        <div className="instructions">WE CREATED THIS FRONTEND TO MAKE IT EASIER: KUSTOMIZE ON HERE, THEN COPY AND PASTE THE DATA BELOW INTO THE "KUSTOMIZE" FUNCTION ON ARBISCAN AND SUBMIT.</div>
        <div className="instructions">YOU MAY CHOOSE 4 COLORS (DEFAULT COLOR, COLOR #2, COLOR #3, COLOR #4). </div>
        {/* <div className="itemDropKustomETH" onClick={() => handleShow(24)}>LOAD</div> */}
            <div className="itemDropKustomETH" onClick={() => handleShow(29)}>RESET (BLANK)</div>
            <div className="itemDropKustomETH" onClick={() => handleShow(28)}>SELECT DEFAULT COLOR</div>
            <div className="itemDropKustomETH" onClick={() => handleShow(27)}>SELECT COLOR #2</div>
            <div className="itemDropKustomETH" onClick={() => handleShow(26)}>SELECT COLOR #3</div>
            <div className="itemDropKustomETH" onClick={() => handleShow(25)}>SELECT COLOR #4</div>


            <div className="itemDropKustomETH" onClick={() => handleShow(2)}>DRAW WITH COLOR #2</div>
            <div className="itemDropKustomETH" onClick={() => handleShow(1)}>DRAW WITH COLOR #3</div>
            <div className="itemDropKustomETH" onClick={() => handleShow(0)}>DRAW WITH COLOR #4</div>

            <div className="itemDropKustomETH" onClick={() => submitCustom()}>SUBMIT</div>
            <div className="customMessage">{msg1}</div>
            <div className="customMessage">{msg2}</div>
            <div className="customMessage">{msg3}</div>
            <div className="customMessage">{msg4}</div>
            <div className="customMessage">{msg5}</div>
            <div className="customMessage">{msg6}</div>


          </div>
        :
        <div className="CustomSVGRightSide">
          <div className="CustomHeader">MENU</div>
          <Link to='/kustomarbmenu' className="itemDropKustomETH">BACK</Link>
          <div className="instructions">BETTER UI/UX IS ON THE WAY. UNTIL THEN, KUSTOMIZE ON ARBITRUM BY HEADING TO https://arbiscan.io/address/0x7e79c121a912ebebb63af676b4f277fb1701970b AND INTERACT DIRECTLY WITH THE CONTRACT.</div>
          <div className="instructions">WE HAVE NO CONTROL OVER ARBISCAN AND ARE NOT LIABLE FOR ANY FAILED/INCORRECT TRANSACTIONS.</div>
        <div className="instructions">WE CREATED THIS FRONTEND TO MAKE IT EASIER: KUSTOMIZE ON HERE, THEN COPY AND PASTE THE DATA BELOW INTO THE "KUSTOMIZE" FUNCTION ON ARBISCAN AND SUBMIT.</div>
        <div className="instructions">YOU MAY CHOOSE 4 COLORS (DEFAULT COLOR, COLOR #2, COLOR #3, COLOR #4). </div>
        {/* <div className="itemDropKustomETH" onClick={() => handleShow(24)}>LOAD</div> */}
            <div className="itemDropKustomETH" onClick={() => handleShow(29)}>RESET (BLANK)</div>
            <div className="itemDropKustomETH" onClick={() => handleShow(28)}>SELECT DEFAULT COLOR</div>
            <div className="itemDropKustomETH" onClick={() => handleShow(27)}>SELECT COLOR #2</div>
            <div className="itemDropKustomETH" onClick={() => handleShow(26)}>SELECT COLOR #3</div>
            <div className="itemDropKustomETH" onClick={() => handleShow(25)}>SELECT COLOR #4</div>


            <div className="itemDropKustomETH" onClick={() => handleShow(2)}>DRAW WITH COLOR #2</div>
            <div className="itemDropKustomETH" onClick={() => handleShow(1)}>DRAW WITH COLOR #3</div>
            <div className="itemDropKustomETH" onClick={() => handleShow(0)}>DRAW WITH COLOR #4</div>

            <div className="itemDropKustomETH" onClick={() => submitCustom()}>SUBMIT</div>
            <div className="customMessage">{msg1}</div>
            <div className="customMessage">{msg2}</div>
            <div className="customMessage">{msg3}</div>
            <div className="customMessage">{msg4}</div>
            <div className="customMessage">{msg5}</div>
            <div className="customMessage">{msg6}</div>



        </div>}
        <div className="CustomSVGRightSide">
            {/* background  */}
            <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="{w}pt" height="{h}pt" viewBox="0 0 1600.000000 800.000000" preserveAspectRatio="xMidYMid meet" xmlnsXlink="http://www.w3.org/1999/xlink">

{parse('<defs><polygon points="24.8,22 37.3,29.2 37.3,43.7 24.8,50.9 12.3,43.7 12.3,29.2" id="hex" transform="scale(1.8,1.8)" /></defs>')}
{parse('<g transform="translate(0.000000,800.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">')}
{parse('<path d="M0 4000 l0 -4000 8000 0 8000 0 0 4000 0 4000 -8000 0 -8000 0 0 -4000z" fill="'+String(svgBackgroundColor[bgColor]) + '</g>')}






            {/* {parse('<use xlinkHref="#cube" x="487" y="540" fill="#000000"/>')} */}

            {/* {peices.split("").forEach(character => {if (character == "0") {return parse('<use xlinkHref="#cube" x="480" y="240" fill="#000000"/>')}})} */}

            {peices.map((value, index) => {

              let color;

              if (parseInt(value) === 1) {
                color = svgBackgroundColor[four_colors[0]]
              } else {
                if (parseInt(color1[index]) === 1){
                  color = svgBackgroundColor[four_colors[1]]
                } else {
                  if (parseInt(color2[index]) === 1){
                    color = svgBackgroundColor[four_colors[2]]
                  } else {
                    color = svgBackgroundColor[four_colors[3]]
                  }
                }
              }
                // let color = color1[index] == 1 ? svgBackgroundColor[three_colors[0]] : color2[index] == 1 ? svgBackgroundColor[three_colors[1]] : svgBackgroundColor[three_colors[2]]
                let temp = svgData[index] + '" fill="' + color;
                return parse(temp)
                // return parse('<use xlinkHref="#cube" x="480" y="240" fill="#000000"/>')

         })}

            {parse('<g transform="translate(0.000000,800.000000) scale(0.100000,-0.100000)" fill="#F5F5F5" stroke="none"> <path d="M14720 890 l0 -110 -110 0 -110 0 0 -110 0 -110 110 0 110 0 0 -220 0 -220 110 0 110 0 0 220 0 220 110 0 110 0 0 110 0 110 -110 0 -110 0 0 110 0 110 -110 0 -110 0 0 -110z M15440 890 l0 -110 -110 0 -110 0 0 -110 0 -110 110 0 110 0 0 -220 0 -220 110 0 110 0 0 220 0 220 110 0 110 0 0 110 0 110 -110 0 -110 0 0 110 0 110 -110 0 -110 0 0 -110z"/></g></svg>')}
            </svg>
          </div>
      </div>
  );
}






